
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { StickyChilli_1Screen } from "../StickyChilli/game_1Screen";


    export class StickyChilliLink_1Screen extends StickyChilli_1Screen {

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "StickyChilliLink") {
            super(multigameParams, initData, gameName);
        }

    }